import { favouritesAxiosInstance as network } from '../../axios';
import { Endpoints, SiteTypes } from '../../enums';
import { FetchListsResponse } from '../../types';
import { endpointReplace } from '../../utils/endpointReplace';

export const getLists = async () => {
  const path = endpointReplace({ ':siteType': SiteTypes.FAVOURITES }, Endpoints.Lists);
  const authentication = await globalThis.ikea.mvAgent.authentication?.isLoggedIn();

  const response = await network.get<FetchListsResponse>(path, {
    ...((authentication?.authToken ?? authentication?.guestToken) && {
      headers: {
        'x-auth-token': authentication.authToken ?? authentication.guestToken,
      },
    }),
  });

  return response.data.results;
};
